import styled from "styled-components";

interface LoadingStyledProps {
	$width: string;
}

export const LoadingStyled = styled.div<LoadingStyledProps>`
	/* height: 100%;
	width: 100%; */

	display: flex;
	justify-content: center;
	align-items: center;
	img {
		/* width: var(${(props) => props.$width || ""}); */
		width: 100%;
		max-width: ${(props) => props.$width};
		animation: is-rotating 2.3s infinite;
	}

	@keyframes is-rotating {
		to {
			transform: rotate(-1turn);
		}
	}
`;
